// extracted by mini-css-extract-plugin
export default {"voucherBannerText":"fbanVz","infoIcon":"_nPWTY"};